import { LiveControlStatusCount } from "./cto/ctoTypes";
import { Status } from "./statusTypes";
import { User } from "./userTypes";

export enum Sort {
  A_FIRST = -1,
  B_FIRST = 1,
  EQUAL = 0,
}

export interface Log {
  created_at: Date | null;
  created_by: User | null;
}

export interface StepApproval {
  step_approved_by: User | null;
  approved: boolean;
  comment: string;
  step_approved_at: Date | null;
}

export type LinkedItemInfo = {
  name: string;
  code: string;
  status_code?: Status;
  status_color?: string;
  status_label?: string;
};

export type LinkedList =
  | LinkedItemInfo
  | string
  | (LinkedItemInfo & {
      hazardCode?: string;
      hazardName?: string;
      barriers?: string[];
    });

export enum SeverityType {
  Normal = -1,
  Warning = 0,
  Mitigated = 5,
  Critical = 10,
  NoInfo = -99,
}

export interface HeaderStatus {
  isDisabled?: boolean;
  status_code: number | number[];
  status_color: string;
  status_label: string;
  sces_qty?: number;
  tags_qty?: number;
  ctos_qty?: number | LiveControlStatusCount;
  //TODO - CHECK TYPESCRIPT FIX
  qty?: number;
  wonos_qty?: number;
  tooltipText?: string;
}

export interface SelectOption {
  id: string | number;
  label: string;
}

export interface FileProps {
  attachment_id: number;
  file_name: string;
}

export enum RiskLevel {
  veryLow = "Very Low",
  low = "Low",
  medium = "Medium",
  high = "High",
  veryHigh = "Very High",
}
